module.exports = __webpack_public_path__ + "img/c26b9a7.jpg";